// extracted by mini-css-extract-plugin
module.exports = {"menuComponent":"filterInput_menuComponent__2ejL2","iconColor":"filterInput_iconColor__2Wbk9"};